import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Loupe",
    description: "A study in glass over type: one enormous word, a receding measuring grid, and a living drop of liquid glass that magnifies and bends every letter it crosses.",
    placeholder: "A drop of glass on a page of type.",
    url: getOrigin()
}
